import * as React from 'react';

import { InputChangeHandler } from 'types/typescript/eventHandlers';

export type FileReaderFile = {
  dataURL: string;
  name: string;
};

type Props = {
  onRead: (file: FileReaderFile) => void;
};

/**
 * A hidden file input component to read file as dataURL.
 *
 * someComponentMethod = () => this.c.openExplorer();
 *
 * render = () => {
 *   <FilePicker ref={c => (this.c = c)} onFileLoaded={(file) => console.log(file.dataURL)} />
 * }
 *
 */
class RFileReader extends React.Component<Props> {
  input: HTMLInputElement | null = null;

  openExplorer = () => {
    if (this.input) {
      this.input.click();
    }
  };

  handleFileSelection: InputChangeHandler = event => {
    const file: File | undefined = (event.target.files && event.target.files[0]) || undefined;
    const fileReader = new FileReader();

    if (!file) {
      return;
    }

    fileReader.onload = () => {
      const data = fileReader.result;

      if (!data) {
        return;
      }

      this.props.onRead({
        dataURL: data as string,
        name: file.name,
      });
    };

    fileReader.readAsDataURL(file);

    if (this.input) {
      this.input.value = '';
    }
  };

  render() {
    return (
      <input
        type="file"
        style={{ display: 'none' }}
        ref={input => (this.input = input)}
        onChange={this.handleFileSelection}
      />
    );
  }
}

export default RFileReader;
